import auth from '../config/firebase';
import { getCookie } from '../cookies';
import apiClient from './axiosClient';
import DeleteCareerConnectionResponse from 'wwg-utilities/dist/dtos/delete-career-connection.response';

const deleteCareerConnectionRequest = async (
  id: string,
): Promise<DeleteCareerConnectionResponse> => {
  const token = (await auth.currentUser?.getIdToken()) || getCookie('token');

  return apiClient
    .delete(`career-connections/${id}`, {
      headers: {
        'Authorization-WWG': `Bearer ${token}`,
      },
    })
    .then((res) => res.data);
};

export default deleteCareerConnectionRequest;
